import split from 'lodash-es/split';
import trim from 'lodash-es/trim';

import { getDomainsUrl } from '@/utils/env';

export const host = process.env.HOST || window.location.host;

const wsptc = window.location.protocol.replace(/^http/, 'ws');
const isDev =
  process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'testnet';
// 根据host获取相关常量及配置
// eslint-disable-next-line no-useless-escape
const reg = /^(.*?\.){0,}(.*?)\.([\w\-]{1,}?)\.(com|cn|io|org|net|nl|hk|ae)/;
const match = reg.exec(host);

const [, , m2, m4] = match || [];
export const hostMatch2 = m2;
export const domain = m4;

export const isMainNet = m2 && (m2 === 'www' || m2 === 'm');
export const isTestNet = m2 && m2.indexOf('testnet') > -1;
export const isBybit = m4 === 'bybit';
export const cookieDomain = isDev
  ? 'localhost'
  : window.location.host.replace(/^www|m|testnet/, '');
export const blogDomain = `https://blog.${domain}.com`;

let api = '';
let ws2 = '';
let dataMore = '';
let chatHostname = '';
if (host.indexOf('www.') !== -1) {
  api = `//${host.replace(/www./, 'api2.')}`;
  ws2 = `${wsptc}//${host.replace(/www./, 'ws2.')}`;
  dataMore = `//${host.replace(/www./, 'whale.')}`;
  chatHostname = `//${host.replace(/www./, 'chat.')}`;
} else {
  api = `//api2-${host}`;
  ws2 = `${wsptc}//ws2-${host}`;
  dataMore = `//whale-${host}`;
  chatHostname = `//chat-${host}`;
}

export function getDomains() {
  return split(getDomainsUrl(), ',').map((item: any) =>
    isMainNet ? `${trim(item)}` : `${m2}.${trim(item)}`,
  );
}

export const genDomains = () => {
  let env = '';
  let domain2 = '';
  let domainType = '';
  const hostSplits = window.location.hostname.split('.');
  if (hostSplits.length === 3) {
    // www.bybit.com
    // testnet.bybit.com
    // m.bybit.com
    // m-testnet.bybit.com
    // chat-testnet.bybit.com
    [env, domain2, domainType] = hostSplits;
  }
  if (hostSplits.length === 4) {
    // www.dev-3.bybit.com
    // m.dev-3.bybit.com
    [, env, domain2, domainType] = hostSplits;
  }
  return {
    env,
    documentDomain: `${domain2}.${domainType}`,
  };
};

// 拼接 api2 , eg: api2.dev-1.bybit-a.com
export function getApiServers() {
  const servers = getDomains().map((item: any) =>
    isTestNet ? `api2-${item}` : `api2.${item}`,
  );
  api = isTestNet ? (api = `api2-${host}`) : `${host.replace(/www./, 'api2.')}`;
  return [api, ...servers];
}

// 得到总的线路：默认的线路 + 新配置的几条
// 返回选中的这一条 api + ws
function getRoute() {
  const servers = getApiServers();

  const choosedRouteString = window.localStorage.getItem('choosedRoute');
  let choosedRoute = 0;
  if (choosedRouteString !== undefined && choosedRouteString !== null) {
    choosedRoute = parseInt(choosedRouteString);
  }

  const api = `//${servers[choosedRoute]}`; // 匹配到具体的这一条线路
  const ws2 = isTestNet
    ? `${wsptc}${api.replace(/api2-/, 'ws2-')}`
    : `${wsptc}${api.replace(/api2./, 'ws2.')}`;
  return [api, ws2];
}
[api, ws2] = getRoute();

export const apiUrl = api;
export const ws2Url = ws2;
export const dataMoreUrl = dataMore;
export const chatUrl = `${chatHostname}/chat/by-chat-widget.js`;
export const helpUrl = isBybit
  ? 'https://help.bybit.com/hc'
  : `https://help.${domain}.com/hc`; // 非bybit域名使用zendesk原始域名
export const exportUrl = isMainNet
  ? 'https://public.bybit.com'
  : process.env.EXPORT_URL;
export const i18nUrl = () => {
  // s1主网，t1testnet
  let url = 'https://tms.ffe390afd658c19dcbf707e0597b846d.de/download/trade'; // 测试
  if (isTestNet || isMainNet) {
    url = '/translations/trade';
  }
  return url;
};

// eslint-disable-next-line no-nested-ternary
const affiliatesPrefix = isMainNet ? 'affiliates.' : 'affiliates-testnet.';

export const AFFILIATES_HOST = `https://${affiliatesPrefix}bybit.com`;
